import type {
  LedgerEntry as LedgerEntryDto,
  LocalizedFieldDto,
  NettingAllocation,
  PaymentAllocation as PaymentAllocationType,
} from '@carvia/ros-client-types';
import type { Payment } from '../payments/payment.entity';

export enum CounterpartyType {
  CUSTOMER = 'CUSTOMER',
  AGENCY = 'AGENCY',
  OTHER = 'OTHER',
}

export type LedgerEntry = Omit<
  LedgerEntryDto,
  'paymentAllocations' | 'nettingAllocations' | 'amountToRequestPay'
> & {
  dueDate: string | null;
  serviceDate: string | null;
  createdDate: string;
  updatedDate: string;
  paymentAllocations: PaymentAllocation[];
  nettingAllocations?: NettingAllocation[];
  readableDescription?: LocalizedFieldDto;
  amountToRequestPay: number;
};

export type PaymentAllocation = Omit<PaymentAllocationType, 'payment'> & {
  ledgerEntry: LedgerEntry;
  finalizedAt: string | null;
  createdAt: string;
  updatedDate: string;
  payment: Payment;
};
